import { Heart } from "lucide-react";

interface LivesIndicatorProps {
  lives: number;
  totalLives?: number;
}

export function LivesIndicator({
  lives,
  totalLives = 3,
}: Readonly<LivesIndicatorProps>) {
  return (
    <div
      className="lives-indicator flex items-center justify-center h-[38px] px-[14px] gap-[7px] bg-[#ffffff2e] border !border-[#ffffff96] rounded-[30px] z-[99] hover:opacity-90"
      aria-label={`${String(lives)} of ${String(totalLives)} lives remaining`}
    >
      {Array.from({ length: totalLives }, (_, index) => {
        const isRemaining = index < lives;
        return (
          <Heart
            key={index}
            size={18}
            fill={isRemaining ? "var(--game-accent)" : "none"}
            stroke={isRemaining ? "var(--game-accent)" : "rgba(255,255,255,0.4)"}
            aria-hidden="true"
          />
        );
      })}
    </div>
  );
}
